module.exports = __webpack_public_path__ + "static/img/about-banner1.dbb100ee.png";